import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { StorageService } from '@app/core/services/client-services/storage-service/storage.service';
import { LoginService } from '@app/shared/services/login.service';
import { DiscrepanciesService } from 'api/services';
import { AuthService } from '@app/core/services/auth.service';
import { lastValueFrom } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { UnauthFooterComponent } from '../../components/unauth-footer/unauth-footer.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-login-callback',
    templateUrl: './login-callback.component.html',
    styleUrls: ['./login-callback.component.scss'],
    imports: [
        MatProgressSpinner,
        MatButton,
        UnauthFooterComponent,
        TranslateModule,
    ],
})
export class LoginCallbackComponent implements OnInit {
    constructor(
        private sessionService: SessionService,
        private storageService: StorageService,
        private discrepanciesService: DiscrepanciesService,
        private router: Router,
        private authService: AuthService,
        private loginService: LoginService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.handleBffCallback();
    }

    private async handleBffCallback(): Promise<void> {
        try {
            // Load user data -- DLS_SESSION_ID cookie is already set by BFF
            await this.sessionService.loadUserFromApi();

            // Load discrepancy choices asynchronously
            this.loadDiscrepancyChoices();

            // Get the redirect route saved before BFF login
            const redirectRoute = this.authService.getPostLoginRedirect();
            this.authService.clearPostLoginRedirect();

            // Navigate to target route
            if (redirectRoute && redirectRoute !== '/') {
                const result = await this.router.navigateByUrl(redirectRoute);
                if (!result) {
                    await this.loginService.routeToPage(
                        this.sessionService.getSession()?.termsOfService
                            ?.accepted
                    );
                }
            } else {
                await this.loginService.routeToPage(
                    this.sessionService.getSession()?.termsOfService?.accepted
                );
            }
        } catch (error) {
            // Failed to load user -- session cookie might be invalid
            await this.router.navigate(['/login']);
        }
    }

    private async loadDiscrepancyChoices(): Promise<void> {
        // Always reload to avoid stale discrepancy choices (2.4.2 fix),
        // using HEAD's async/await style.
        try {
            const response = await lastValueFrom(
                this.discrepanciesService.getDiscrepanciesChoices()
            );
            this.storageService.setItem('discrepancyChoices', response);
        } catch (error) {
            console.warn('Failed to load discrepancy choices:', error);
        }
    }
}
